// extracted by mini-css-extract-plugin
export default {"symbol":"symbol__VepResultsGene__AS29A"};